// src/axiosConfig.js
import axios from 'axios';

const axiosInstance = axios.create({
baseURL: 'https://apis.trulyyourswelfare.com/api/v1/',
//baseURL: 'http://localhost:7000/api/v1/'
});

// Request interceptor to add the accessToken to headers
axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('accessToken'); // Replace with your token retrieval logic
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
export default axiosInstance;
